import { ImageLoaderProps, ImageProps } from 'next/legacy/image'

import ENV_VARS from '@/config'

type TheUnit = string | number
const getSize = (width: TheUnit, height: TheUnit) => {
  if (!height && !width) return ''
  return `/${width}x${height}`
}

const getValues = (...values: unknown[]) =>
  values.map(v => (v ? `/${v}` : '')).join('')

interface Opts {
  width?: TheUnit
  height?: TheUnit
  fit?: null | string
  type?: null | string
  quality?: number | null
  filterType?: 'blur' | 'quality'
}
export const getImageUrl = (
  src: string | null,
  {
    width = '',
    height = '',
    fit = null,
    type = null,
    quality = 70,
    filterType = 'quality'
  }: Opts = {} as Opts
) => {
  if (!src) return ''
  const match = src.match(/static_file.+$/)
  if (!match) return ''
  const image = match[0]
    .replace(/^\//, '')
    .replace(/\(/g, '%28')
    .replace(/\)/g, '%29')
    .replace(/'/g, '%27')
    .replace(/"/g, '%22')

  const qualityStr =
    quality !== null ? `filters:${filterType}(${quality})/` : ''
  return `${ENV_VARS.IMAGES_URL}${getSize(width, height)}${getValues(
    fit,
    type
  )}/${qualityStr}${image}`
}

export const cdnLoader =
  (height?: TheUnit) =>
  ({ src, width, quality }: ImageLoaderProps) => {
    const extra =
      typeof height !== 'undefined'
        ? {
            height: height === 'width' ? width : height
          }
        : {}
    return getImageUrl(src, { width, quality, ...extra })
  }

export const blurImage = (
  src: ImageProps['src'],
  opts: {
    width?: number
    filterType?: 'blur' | 'quality'
    quality?: number
  } = {}
) => {
  const { width = 8, filterType = 'quality', quality = 70 } = opts
  return getImageUrl(src.toString(), { width, filterType, quality })
}
